import type { FC } from "react";
import type CalendarProps from "../Calendar.properties.ts";
import type { CustomCalendarContainerProperties } from "./CustomCalendarContainer.properties.ts";
import styles from "./CustomCalendarContainer.module.css";

export const CustomCalendarContainer: FC<
  CalendarProps & CustomCalendarContainerProperties
> = ({
  className,
  children,
  showNextThreeMonthButtons,
  nextSixMonthEnds,
  onCalendarButtonClick,
}) => {
  return (
    <div className={className}>
      <div>{children}</div>

      {showNextThreeMonthButtons && (
        <div className={styles.calendarButtonContainer}>
          {nextSixMonthEnds.map(({ label, date }) => (
            <button
              onClick={() => onCalendarButtonClick(date)}
              key={label}
              className={styles.calendarButton}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#e5e7eb")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#f9fafb")
              }
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
